<template>
  <FormSection title="Podcast">
    <template #text>
      Ändere die allgemeinen Angaben zu deinem Podcast, um die Anzeige hier im Studio anzupassen
    </template>
    <template #form>
      <PodcastForm :resource="resource" :errors="errors" />
    </template>
  </FormSection>
  <section v-if="owned" class="py-4 px-4 sm:p-6 lg:pb-8">
    <p class="label py-5">
      Möchtest du den Podcast aus dem St. Audio Studio entfernen?
    </p>
    <DeleteButton @click="onDelete">
      Podcast löschen
    </DeleteButton>
  </section>
  <FormButtons>
    <div class="space-x-2">
      <BackButton />
      <SubmitButton @click="onSubmit" :load="updating" :success="success">
        Aktualisieren
      </SubmitButton>
    </div>
  </FormButtons>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useRetrieveResource } from '@/client/actions';
import { useUpdateResource } from '@/client/actions';

const store = useStore();
const router = useRouter();

const parent = computed(() => store.getters['context/context'].id);
const owned = computed(() => store.getters['context/context'].own_podcast);

const retrieveTarget = computed(() => '/api/podcasts/' + parent.value);
const retrieveAction = useRetrieveResource(retrieveTarget);

const { retrieve, retrieving, resource } = retrieveAction;

const updateTarget = computed(() => '/api/podcasts/' + parent.value);
const updateAction = useUpdateResource(updateTarget, resource);

const { update, updating, errors, message, success } = updateAction;

const onMount = onMounted(() => retrieve());
const onSuccess = () => null; //TODO
const onSubmit = () => update(onSuccess);
const onDelete = () => router.push({name: 'podcast.delete'});

</script>

<style scoped>
.label
{
  @apply block;
  @apply text-sm;
  @apply font-medium;
  @apply text-gray-700;
};
</style>
